import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { BsModalService } from 'ngx-bootstrap/modal';
import { of } from 'rxjs/index';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AdminCommonService } from '../../../services/admin/admin-common.service';
import { selectAction } from '../../../shared/state/index.state';
import { AdminActions } from './admin.actions';

@Injectable()
export class AdminEffect {

    constructor(private actions$: Actions,
                private modalService: BsModalService,
                private adminCommonService: AdminCommonService) {
        // this.listenToRouter();
    }

    @Effect() getAvailableUserStatuses$ = this.actions$
        .pipe(
            selectAction(AdminActions.GET_AVAILABLE_USER_STATUSES),
            switchMap(() =>
                this.adminCommonService.getAvailableUserStatuses()
                    .pipe(
                        map((userStatuses: Array<any>) =>
                            AdminActions.GET_AVAILABLE_USER_STATUSES_SUCCESS(userStatuses)
                        ),
                        catchError(error =>
                            of(AdminActions.GET_AVAILABLE_USER_STATUSES_FAIL({error}))
                        )
                    )
            )
        );
}
